import { jsx as _jsx } from "react/jsx-runtime";
import Icon from "../Icon";
const BottomTabIcon = ({ color, iconType, size = "sm" }) => {
    return _jsx(Icon, { type: iconType, color: color, size: size });
};
export default BottomTabIcon;
